export const TRIP = 'TRIP';
export const TRIPS = 'TRIPS';
export const TRIPMAP = 'TRIPMAP';
export const TRIP_SELECTIONS = 'TRIP_SELECTIONS';
export const TRIPMAP_UPDATE = 'TRIPMAP_UPDATE';
export const TRIP_POINTS_MAP = 'TRIP_POINTS_MAP';
export const TRIP_POINTS_MAP_UPDATE = 'TRIP_POINTS_MAP_UPDATE';
export const VEHICLE = 'VEHICLE';
export const TIMEZONE = 'TIMEZONE';